import { gql } from "@apollo/client";

const LOGIN = gql`
  mutation loginMutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      expiresAt
    }
  }
`;

export default LOGIN;
